import React from 'react';
import moment from 'moment';
import { View, Text } from '@react-pdf/renderer';
import { styles } from '../../../utils/styles';
export const MeasuresDatePDF = ({
  measure
}) => {
  const measureVisitDate = moment(measure.visitdate).format('L');
  const measureVisitDateTime = moment(measure.visitdatetimeshifted).format('LT');
  const measureCreateDate = moment(measure.measuredate).format('L');
  const measureCreateTime = moment(measure.measuredatetimeshifted).format('LT');
  return /*#__PURE__*/React.createElement(View, {
    style: styles.width25
  }, /*#__PURE__*/React.createElement(Text, {
    style: styles.CPFTableDetailsText
  }, measure.visitdate && measure.visitdatetimeshifted && `${measureVisitDate}, ${measureVisitDateTime}` || measure.measuredate && measure.measuredatetimeshifted && `${measureCreateDate}, ${measureCreateTime}`));
};